import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { quickLinks } from "~/slices/QuickLinks/fragment";
import { storeFinanceBlock } from "~/slices/StoreFinanceBlock/fragment";

const PAGE_TYPE = "Store_page";
const QUERY_STORE_PAGE = gql`
  query store_page($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}: store_page(uid: $uid, lang: $lang) {
      store_name
      show_opening_hours
      opening_hours_text
      store_review_id
      store_api
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      campaign_sale_link {
        ... on Campaign_sale1 {
          _meta {
            uid
          }
        }
      }
      store_page_content {
        ... on ${PAGE_TYPE}_content {
          title
          body {
            ...quickLinks
            ...storeFinanceBlock
          }
        }
      }
    }
  }
  ${quickLinks}
  ${storeFinanceBlock}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_STORE_PAGE };
